import Vue from "vue";
import { Component } from "vue-property-decorator";


import { ModelLockApi } from "../../scripts/ah.mb.model-lock-services";

import { bootbox } from "../../infrastructure/bootbox-shim";
import { ClientNotifier } from "../../scripts/ah.mb.client-notifications";


@Component
export default class ModelLocksAdminIndex extends Vue {

    private  modelLockServices = new ModelLockApi();
    clientNotifier = new ClientNotifier();

    lockAllModels() {
        bootbox.confirm("Lock all models for editing?",
            ok => {
                if (ok) {
                    var notification = this.clientNotifier.showBusyNotification("Locking all models...");
                    this.modelLockServices.lockAllModels()
                        .then(() => {
                            this.clientNotifier.clear(notification);
                        });
                }
            });
    }

    unlockAllModels() {
        bootbox.confirm("Unlock all models for editing?",
            ok => {
                if (ok) {
                    var notification = this.clientNotifier.showBusyNotification("Unlocking all models...");
                    this.modelLockServices.unlockAllModels()
                        .then(() => {
                            this.clientNotifier.clear(notification);
                        });

                }
            });

    }

}





// WEBPACK FOOTER //
// ./ClientApp/components/model-locks/model-locks-admin.ts